import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Chip,
  CircularProgress,
  Alert,
  Snackbar,
  SelectChangeEvent
  
} from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, CloudUpload as CloudUploadIcon, Image as ImageIcon } from '@mui/icons-material';
import { bannersAPI, Banner as APIBanner ,createBanner,updateBanner} from '../services/api';
// Ensure bannersAPI has update, create, and delete methods in ../services/api
import { title } from 'process';

// Define your API base URL here (update the value as needed)
const IMG_BASE_URL = 'http://protoncarwashapi.csnsindia.com:7089'; // or your actual API base URL
import { IMG_PATH_URL } from '../services/api';
console.log('Image url',IMG_PATH_URL);
import { create } from 'domain';

type BannerFormData = {
  title: string;
  description: string;
  image_url: string ;
  bannerFile: File | null;
  status: '1' | '0';
  start_date?: string | null;
  end_date?: string | null;
};

type SnackbarState = {
  open: boolean;
  message: string;
  severity: 'success' | 'error';
};

const Banners: React.FC = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [editingBanner, setEditingBanners] = useState<APIBanner | null>(null);
  const [banners, setBanners] = useState<APIBanner[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  
  const navigate = useNavigate();
  const [formData, setFormData] = useState<BannerFormData>({
    title: '',
    description: '',
    image_url: '',
    start_date:'',
    end_date: '',
    bannerFile: null,
    status: '1'
  });
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success'
  });

  // Fetch banners on component mount
  
   useEffect(() => {
      const fetchBanners = async () => {
        try {
          setLoading(true);
          const response = await bannersAPI.getAll();
          const data = Array.isArray(response) ? response : [];

          // The API layer now normalizes banner fields (status: boolean, display_order: number)
         setBanners(data as APIBanner[]);
          setError(null);
        } catch (err) {
          const errorMessage = err instanceof Error ? err.message : 'Failed to fetch banners';
          setError(errorMessage);
          setSnackbar({
            open: true,
            message: errorMessage,
            severity: 'error'
          });
        } finally {
          setLoading(false);
        }
      };
  
      fetchBanners();
    }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement >) => {
    const { name, value } = e.target;
   
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

 const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

      setFormData(prev => ({
        ...prev,
        bannerFile: file,       // real file for upload
        image_url: previewUrl,  // preview only
      }));
    //  }
   };

   // Clean up object URLs to avoid memory leaks
    useEffect(() => {
      return () => {
        if (formData.image_url && formData.image_url.startsWith("blob:")) {
          URL.revokeObjectURL(formData.image_url);
        }
      };
    }, [formData.image_url]);

const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  try {
    setLoading(true);

    const uploadedPath = await bannersAPI.uploadImage(file);

    setFormData(prev => ({
      ...prev,
      image_url: uploadedPath
    }));

    // showSnackbar("Image uploaded", "success");

  } catch {
    // showSnackbar("Image upload failed", "error");
  } finally {
    setLoading(false);
  }
};

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const formatDate = (dateString?: string | null) => {
    if (!dateString) return "";
    return new Date(dateString).toISOString().split("T")[0];
  };

  const handleOpenDialog = (banner?: APIBanner) => {
    if (banner) {
      setEditingBanners(banner);
      // setFormData({
      //   title: banner.title|| '',
      //   description: banner.description || '',
      //   image_url: banner.image_url || '',
      //   start_date: banner.start_date || '',
      //   end_date: banner.end_date || '',
      //   // convert boolean status -> form value
      //   status: banner.status ? '1' : '0',
      //   bannerFile: null
      // });
      setFormData({
      title: banner.title || "",
      description: banner.description || "",
      image_url: IMG_PATH_URL + banner.image_url,   // FULL path for preview
      start_date: formatDate(banner.start_date),
      end_date: formatDate(banner.end_date),
      status: banner.status ? "1" : "0",
      bannerFile: null
    });
    } else {
      setEditingBanners(null);
      setFormData({
        title: "",
        description: "",
        image_url: "",
        start_date: "",
        end_date: "",
        status: "1",
        bannerFile: null
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingBanners(null);
  };
  

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

 const toggleStatus = async (id: number, currentStatus: boolean) => {
    try {
      setLoading(true);
      const newStatus = currentStatus === true ? '0' : '1';

      // Find the banner to update
      const bannerToUpdate = banners.find(c => c.banner_id === id);
      if (!bannerToUpdate) {
        throw new Error('Banner not found');
      }

      // Update the status with all required fields (ensure strings, provide defaults)
      await bannersAPI.update(id, {
        title: bannerToUpdate.title ?? '',
        description: bannerToUpdate.description ?? '',
        image_url: bannerToUpdate.image_url ?? '',
        status: newStatus === '1'
      });

      showSnackbar(`Banner marked as ${newStatus}`, 'success');

      // Update the local state (keep status as the same string type used in Banner)
      setBanners(prevBanners =>
        prevBanners.map(banner =>
          banner.banner_id === id
            ? {
                ...banner,
                status: newStatus === '1' ? '1' : '0'
              }
            : banner
        )
      );
    } catch (err) {
      console.error('Error toggling status:', err);
      const errorMessage = err instanceof Error ? err.message : 'Failed to update banner status';
      showSnackbar(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     setLoading(true);
  //     // Prepare the base user data according to the API expectations
  //     if (formData.bannerFile) {
  //     const image_url =formData.bannerFile;
  //     } else if (formData.image_url && !formData.image_url.startsWith('blob:')) {
  //       const image_url = new URL(formData.image_url, window.location.origin);
  //     }
  //     const url = new URL(formData.image_url, window.location.origin);
  //     const baseBannerData = {
  //       title: formData.title,
  //       description: formData.description,
  //       image_url: formData.image_url,
  //       start_date: formData.start_date || null,
  //       end_date: formData.end_date || null,
  //       status: formData.status
  //     };

  //     if (editingBanner) {
  //       // For updates, convert status to boolean and send the base banner data
  //       await bannersAPI.update(editingBanner.banner_id, {
  //         ...baseBannerData,
  //         status: baseBannerData.status === '1'
  //       });
  //       showSnackbar('Banner updated successfully', 'success');
  //     } else {
  //       // For new banners, ensure status is sent as boolean
  //       const newBannerData = {
  //         ...baseBannerData,
  //         status: baseBannerData.status === '1',
  //         start_date: baseBannerData.start_date ?? undefined,
  //         end_date: baseBannerData.end_date ?? undefined
  //       };

  //       await bannersAPI.create(newBannerData);
  //       showSnackbar('Banner created successfully', 'success');
  //     }

  //     // Refresh the banners list
  //           const response = await bannersAPI.getAll();
  //           setBanners(Array.isArray(response) ? response : []);

  //     // Reset form and close dialog
  //     setFormData({
  //       title: '',
  //       description: '',
  //       image_url: '',
  //       start_date: '',
  //       end_date: '',
  //       status: '1',
  //       bannerFile:null
  //     });
  //     setOpenDialog(false);
  //   } catch (err) {
  //     console.error('Error saving banner:', err);
  //     const errorMessage = err instanceof Error ? err.message : 'Failed to save banner';
  //     showSnackbar(errorMessage, 'error');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
  
      try {
        const fd = new FormData();

        fd.append("title", formData.title);
        fd.append("description", formData.description);
        fd.append("start_date", formData.start_date || "");
        fd.append("end_date", formData.end_date || "");
        fd.append("status", formData.status);

        // If image changed, upload file
        if (formData.bannerFile) {
          fd.append("image_url", formData.bannerFile);
        } 
        // If editing and user did NOT change the image
        else if (editingBanner?.image_url) {
          fd.append("image_url", editingBanner.image_url);
        }
  
       if (editingBanner) {
          await updateBanner(editingBanner.banner_id, fd);
          showSnackbar("Banner updated", "success");
        } else {
          await createBanner(fd);
          showSnackbar("Banner created", "success");
        }

        setOpenDialog(false);
        // Refresh the banners list
            const response = await bannersAPI.getAll();
            setBanners(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error(error);
        showSnackbar("Failed to save banner", "error");
      }
    };

  const handleDelete = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this banner?')) {
      try {
        setLoading(true);
        await bannersAPI.delete(id);
        showSnackbar('Banner deleted successfully', 'success');

        // Refresh the banners list
        const response = await bannersAPI.getAll();
        const data = Array.isArray(response) ? response : [];
        setBanners(data);
      } catch (err) {
        console.error('Error deleting banner:', err);
        showSnackbar('Failed to delete banner', 'error');
      } finally {
        setLoading(false);
      }
    }
  };
  
// console.log('Banners Data fetch');

  return (
    <Box sx={{ p: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        
         <Typography variant="h4" gutterBottom>
                                         Banners
                               </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => handleOpenDialog()}
          disabled={loading}
        >
          Add Banner
        </Button>
      </Box>
      {/* Error Alert */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Loading Overlay */}
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
          <CircularProgress />
        </Box>
      )}

      <Paper sx={{ p: { xs: 0, sm: 0 } }}>
        
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Image</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Start Date</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>End Date</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {banners.length === 0 && !loading ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 8 }}>
                    <Typography variant="body1" color="text.secondary">
                      No banners found. Click "Add New Banner" to create one.
                    </Typography>
                  </TableCell>
                </TableRow>
                ) : (
                banners.map((banner) => (
                  <TableRow key={banner.banner_id} hover>
                    <TableCell>{banner.banner_id}</TableCell>
                    <TableCell>
                        <Typography variant="body2" fontWeight={500}>
                          {banner.title}
                        </Typography>
                    </TableCell>
                    <TableCell>
                      <img
                        src={IMG_PATH_URL + banner.image_url}
                        alt={banner.title}
                        style={{ width: 80, height: 50, objectFit: 'cover', borderRadius: 6 }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={banner.status ? 'Active' : 'Inactive'}
                        size="small"
                        onClick={() => toggleStatus(banner.banner_id, !!banner.status)}
                        sx={{ cursor: 'pointer', minWidth: 80 }}
                      />
                    </TableCell>
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                      {banner.start_date ? new Date(banner.start_date).toLocaleDateString() : 'N/A'}
                    </TableCell>
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                      {banner.end_date ? new Date(banner.end_date).toLocaleDateString(): 'N/A'}
                    </TableCell>
                    <TableCell align="right">
                      <IconButton
                        onClick={() => handleOpenDialog(banner)}
                        color="primary"
                        size="small"
                        disabled={loading}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(banner.banner_id)}
                        size="small"
                        disabled={loading}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {editingBanner ? 'Edit Banner' : 'Add New Banner'}
          </Typography>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="image_url"
                  name="image_url"
                  value={formData.image_url}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid> */}
              <Grid item xs={12}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle1" gutterBottom>
                    Banner Image
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
                    <Box sx={{
                      width: 100,
                      height: 100,
                      border: '1px dashed #ccc',
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'hidden',
                      backgroundColor: '#f9f9f9'
                    }}>
                      {formData.image_url ? (
                        <img
                          src={formData.image_url}
                          alt="Preview"
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      ) : (
                        <ImageIcon color="action" sx={{ fontSize: 30, opacity: 0.5 }} />
                      )}
                    </Box>
                    <Box>
                      <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                      >
                        {formData.image_url ? 'Change Banner' : 'Upload Banner'}
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                      </Button>
                      {formData.image_url && (
                        <Button
                          color="error"
                          size="small"
                          onClick={(e) => {
                            e.preventDefault();
                            setFormData(prev => ({
                              ...prev,
                              image_url: '',
                              bannerFile: null
                            }));
                          }}
                          sx={{ ml: 1 }}
                        >
                          Remove
                        </Button>
                      )}
                      <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary' }}>
                        Recommended size: 100x100px. SVG, PNG or ICO format preferred.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Start Date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="End Date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    name="status"
                    value={formData.status}
                    label="Status"
                    onChange={(e: SelectChangeEvent<string>) => handleSelectChange(e)}
                    required
                  >
                    <MenuItem value="1">Active</MenuItem>
                    <MenuItem value="0">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button onClick={handleCloseDialog} disabled={loading}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={16} /> : null}
            >
              {editingBanner ? 'Update' : 'Add'} Banner
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Banners;
